import { en } from './en';
import { uk } from './uk';
import type { Locale, Messages } from './types';

export type { Locale, Messages, TutorialStep } from './types';
export { LOCALE_NATIVE_LABELS } from './nativeLabels';

const STORAGE_KEY = 'pixotah.locale';
const TUTORIAL_KEY = 'pixotah.tutorialSeen';

const CATALOG: Record<Locale, Messages> = { en, uk };

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'en' || value === 'uk';
}

export function readStoredLocale(): Locale {
  if (typeof localStorage === 'undefined') return 'en';
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (isLocale(raw)) return raw;
  } catch {
    /* private mode */
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language.toLowerCase() : 'en';
  return nav.startsWith('uk') ? 'uk' : 'en';
}

export function writeStoredLocale(locale: Locale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
}

export function hasSeenTutorial(): boolean {
  try {
    return localStorage.getItem(TUTORIAL_KEY) === '1';
  } catch {
    return true;
  }
}

export function markTutorialSeen(): void {
  try {
    localStorage.setItem(TUTORIAL_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function messagesFor(locale: Locale): Messages {
  return CATALOG[locale] ?? en;
}
